<template>
    <div>
        <v-toolbar flat height="40" :color="color">
            <v-toolbar-title class="white--text">
                {{ title }}
            </v-toolbar-title>
            <v-spacer/>
            <slot name="right"></slot>
        </v-toolbar>
    </div>
</template>

<script>
export default {
    props: {
        color: String,
        title: String
    }
}
</script>

<style scoped>

</style>